import { Injectable } from '@angular/core';
import { Observable } from "rxjs";
import { BaseService } from "../BaseService";
import { UrlService } from "../UrlService";
import { ConfigService } from '../ConfigService';
import * as moment from 'moment';
import 'moment-timezone';
import { BlobResponse } from '../../Models/OtherClasses';

@Injectable()
export class LeaveRequestService {
	private url: string;

	constructor(
		private myBaseService: BaseService,
		private configService: ConfigService,
		private urlService: UrlService
	) {
		this.url = urlService.getURL('LeaveRequest');
	}

	loadAllByDateRange(searchObj: ePM.Logic.PersonSearchVM): Observable<ePM.Logic.LeaveRequest[]> {
		return this.myBaseService.post(searchObj, this.url + '/All?export=false');
	}
	loadAllByDateRangeExport(searchObj: ePM.Logic.PersonSearchVM): Observable<BlobResponse> {
		return this.myBaseService.returnBlob(searchObj, this.url + '/All?export=true');
	}
	loadGoneToday(): Observable<ePM.Logic.LeaveRequest[]> {
		return this.myBaseService.loadAll(this.url + '/GoneToday');
	}
	loadCoverageForRequest(id: System.Guid): Observable<ePM.Logic.LeaveRequestCoverage[]> {
		return this.myBaseService.loadAll(this.url + '/Coverage/' + (id || ''));
	}
	loadCompanyPending(): Observable<ePM.Logic.LeaveRequest[]> {
		return this.myBaseService.loadAll(this.url + '/CompanyPending');
	}
	loadAllForPerson(id: System.Guid): Observable<ePM.Logic.ILeaveData[]> {
		return this.myBaseService.loadAll(this.url + '/Overall/' + (id || ''));
	}
	save(tempItem: ECI.Basic.ObjectBase): Observable<ePM.Logic.LeaveRequest> {
		return this.myBaseService.save(tempItem, this.url);
	}
	deleteItem(id: System.Guid): Observable<boolean> {
		return this.myBaseService.deleteItem(id, this.url);
	}
	getEdit(id: System.Guid): Observable<ePM.Logic.LeaveRequest> {
		return this.myBaseService.getEdit(id, this.url);
	}
	getHoursRequested(id: System.Guid, start: Date, finish: Date): Observable<number> {
		var params = '?start=' + this.changeTimeZoneToIsoString(start);
		params += '&finish=' + this.changeTimeZoneToIsoString(finish);
		return this.myBaseService.rawWithParams(id, this.url + '/HoursRequested', params);
	}
	changeTimeZoneToIsoString(date: Date): string {
		if (this.configService.AppConfig.timezone) {
			return moment(date).tz(this.configService.AppConfig.timezone, true).toISOString();
		}
		return date.toISOString();
	}

	get(id: System.Guid): Observable<ePM.Logic.LeaveRequest> {
		return this.myBaseService.get(id, this.url);
	}
	
}
